"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Table = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/Table"));

// Generated by script, don't edit it please.
var Table = (0, _createSvgIcon["default"])({
  as: _Table["default"],
  ariaLabel: 'table',
  category: 'charts',
  displayName: 'Table'
});
var _default = Table;
exports["default"] = _default;
module.exports = exports.default;